/**
 * Вспомогательные функции общей направленности.
 * @module Helpers
 */

import breakpoints from './variables';

/**
 * Создаёт массив из всех целый чисел от start до end.
 *
 * @param {number} start Первое значение.
 * @param {number} end Последнее значение.
 * @return {number[]} Массив значений.
 */
export const range = (start, end) =>
    Array(end - start + 1)
        .fill()
        .map((item, index) => start + index);

/**
 * Переводит переменную даты в строку.
 *
 * @param {Date} date Объект даты.
 * @return {string} Строка даты.
 */
export const dateToString = date => {
    const day = `0${date.getDate()}`.slice(-2);
    const month = `0${date.getMonth() + 1}`.slice(-2);
    const year = date.getFullYear();

    return `${day}.${month}.${year}`;
};

/**
 * Проверка на touch device.
 *
 * @return {boolean} Результат проверки.
 */
export const isTouch = () => 'ontouchstart' in window;

/**
 * Превращает значение любого типа в массив.
 *
 * @param {*} arg Аргумент любого типа.
 */
export const toArray = arg => [].concat(...[arg]);

/**
 * Вычисляет контрольное число.
 *
 * @param {string} str Исходная строка.
 * @param {number[]} coefficients Коэффициенты контрольной суммы.
 * @return {number} Контрольное число.
 */
export const countCheckdigit = (str, coefficients) => {
    const checksum = coefficients.reduce((sum, coefficient, index) => sum + coefficient * str[index], 0);

    return (checksum % 11) % 10;
};

/**
 * Возвращает медиазапрос по имени брейкпоинта.
 *
 * @param {string} breakpointName Имя брейкпоинта из определённых в модуле Variables.
 * @return {MediaQueryList} Соответствующий имени MediaQuery.
 *
 * @example
 * if (media('tablet').matches) {
 *     // Удовлетворяет медиазапросу
 * } else {
 *     // Не удовлетворяет
 * }
 */
export const media = breakpointName => window.matchMedia(`(max-width: ${breakpoints[breakpointName] - 1}px)`);

/**
 * Возвращает текущую локаль по значению lang-атрибута (ru/en).
 *
 * @return {string} Текущая локаль.
 */
export const lang = () => $('html').attr('lang');

/**
 * Возвращает имя клавиши по коду из предопределённого списка.
 *
 * @param {Object} keyCodes Объект из соответствий keyName: keyCode.
 * @param {number} keyCode Код клавиши.
 * @return {string | undefined} Имя клавиши.
 */
export const getKeyName = (keyCodes, keyCode) => {
    const keyEntry = Object.entries(keyCodes).find(entry => entry[1] === keyCode);
    return keyEntry ? keyEntry[0] : undefined;
};

/**
 * Возвращает форму слова в зависимости от числа элементов.
 *
 * @param {number} n Число элементов
 * @param {string[]} forms Формы слова (для 1, 2 и 5 элементов; пример: товар, товара, товаров)
 * @return {string} Выбранная форма слова
 */
export const pluralForm = (n, forms) => {
    if (n % 10 === 1 && n % 100 !== 11) {
        return forms[0];
    }
    return n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? forms[1] : forms[2];
};
